
<script type="text/javascript">
// 定义一些公共的属性和方法
import axios from "axios";
// eslint-disable-next-line no-unused-vars
//获取当前环境
let env = process.env.NODE_ENV;
let OAPI ="";
let BASE_IMG_URL="";
//打包的模式，可能的值：hash、history
let routerMode = process.env.ROUTER_MODE;
console.log(env)
const APPID = process.env.WX_APPID;
const PROTOCOL = (location.protocol == 'http:' ? 'http://' : 'https://');
if (env === "production") {
  //生产环境
  //部分老接口api
  OAPI = PROTOCOL + 'www.xingtanyixun.cn';
  // 图片api
  BASE_IMG_URL = 'https://commonapi.xingtanyixun.cn:60006'
} else if (env === "testing") {
  //测试环境
  // 图片api
  BASE_IMG_URL = 'https://commonapi.xingtanyixun.cn:60006';
  //部分老接口api
  OAPI = PROTOCOL + 'xt.xingtanyixun.cn';
} else {
  //本地环境
  //部分老接口api
  OAPI = PROTOCOL + 'www.xingtanyixun.cn';
  // 图片api
  BASE_IMG_URL = 'https://commonapi.xingtanyixun.cn:60006'
}
const BASE_URL = process.env.BASE_API;
// console.log(process.env)
//cdn地址
const BASE_CDN = 'https://cdns.xingtanyixun.cn/'
let ERROR_COUNT = 0
// 老接口api
//const OAPI = PROTOCOL + 'm.xingtanyipai.cn';
//hash模式path路径
const OAPIPATH = routerMode ==='hash'?'/content/2.0/dist/#':'';
//history模式path路径
//const OAPIPATH = '';
const OAPIURL = PROTOCOL + window.location.host + OAPIPATH;//分享用
const MAINPATH = PROTOCOL + window.location.host + '/content/2.0/dist';
const tokenSecret = 'swdQ41sfg3EFTwddhjndf45g';
export default {
  token: '',
  openid: '',
  getUrlKey(name) {
    // eslint-disable-next-line no-sparse-arrays
    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null
  },
  setToken(token) {
    this.token = token
  },
  setOpenid(openid) {
    this.openid = openid
  },
  checkTokenBeforeAJAX(url, callback, params) {
    let _this = this;
    axios.post(url, params).then(({ data }) => {
      callback(data);
      if (data.success) {
        //callback.apply(_this, [url,params]);
        callback(data);
      } else {
        if (data.StatusCode === 403) {
          ERROR_COUNT++;
          axios
            .get(
              "/WebApi/Service/GetToken"
              //,{headers: { 'Content-Type': 'application/x-www-form-urlencoded'}}
            )
            .then(res => {
              let data = res.data;
              if (ERROR_COUNT < 5) {
                console.log(ERROR_COUNT)
                if (data.success) {
                  if (data.data) {
                    _this['setToken'](data.data.SignToken);
                    _this['checkTokenBeforeAJAX'].apply(_this, arguments);
                  }
                } else {
                  console.log(data.errorMessage);
                }

              } else {
                alert('token接口异常，请联系管理员');
                return false;
              }
            })
            .catch(function (error) {
              console.log(error);
            });
        } else {
          callback(data);
        }
      }
    });
  },
  isweixin() {
    const ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      return true;
    } else {
      return false;
    }
  },
  versions() {
    var u = navigator.userAgent
    // eslint-disable-next-line no-unused-vars
    var app = navigator.appVersion
    return {
      trident: u.indexOf('Trident') > -1, // IE内核
      presto: u.indexOf('Presto') > -1, // opera内核
      webKit: u.indexOf('AppleWebKit') > -1, // 苹果、谷歌内核
      gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') === -1, // 火狐内核
      mobile: !!u.match(/AppleWebKit.*Mobile.*/), // 是否为移动终端
      ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios终端
      android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1, // android终端
      iPhone: u.indexOf('iPhone') > -1, // 是否为iPhone或者QQHD浏览器
      iPad: u.indexOf('iPad') > -1, // 是否iPad
      webApp: u.indexOf('Safari') === -1, // 是否web应该程序，没有头部与底部
      weixin: u.indexOf('MicroMessenger') > -1, // 是否微信 （2015-01-22新增）
      wechatdevtools: u.indexOf('wechatdevtools') > -1, // 是否微信开发者工具
      windowsWechat: u.indexOf('WindowsWechat') > -1, // 是否微信电脑版
      qq: u.match(/\sQQ/i) === ' qq', // 是否QQ
      xtyp: u.indexOf('Xtyp') > -1 // 是否为杏坛艺拍app
    }
  },
  BASE_URL,
  BASE_CDN,
  PROTOCOL,
  OAPI,
  OAPIPATH,
  OAPIURL,
  APPID,
  BASE_IMG_URL,
  tokenSecret,
  MAINPATH
}
</script>
